var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EstimatesTable',{staticClass:"mb-4",attrs:{"items":_vm.estimations,"task-types":_vm.currentProjectTaskTypes,"roles":_vm.estimationRoles},on:{"afterImport":function($event){return _vm.loadEstimates(_vm.project.id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }